const initShowMorePosts = function () {

		$('.ren-show-more-posts').on('click', function () {
			const $button = $(this);
			const buttonText = $button.text();
			const loadingText = $button.data('loading-text');
			const ajaxUrl = $button.data('ajax-url');
			let currentPage = $button.data('current-page');
			const postTypes = $button.data('post-types');
			const maxPage = $button.data('max-page');
			let genre = $button.data('genre');
			const postsContentID = $button.data('posts-cont-id');

			const searchParams = new URLSearchParams(window.location.search);
			if (searchParams.has('genre')) {
				$button.data('genre', searchParams.get('genre'));
				genre = searchParams.get('genre');
			}

			// Get next page number
			currentPage++;

			// Prepare data for request
			const data = {
				action: 'load-more-posts',
				query: {
					post_type: postTypes
				},
				page: currentPage,
				security: WPvars.nonce
			};

			if (genre) data.query.genre = genre;

			// Send ajax request for next page with posts
			// Post type can have array of types
			$.ajax({
				url: ajaxUrl,
				data,
				type: 'POST',
				beforeSend() {
					// Change text while loading
					$button.text(loadingText);
				},
				success(response) {
					if (response) {
						// Restore initial text
						$button.text(buttonText);

						// Hide new items before append to container
						$('#' + postsContentID).append($(response).hide());
						// Use fluent items appearing
						$('#' + postsContentID)
							.children(':not(:visible)')
							.slideDown(300);

						// Save new current page
						$button.data('current-page', currentPage);

						// if last page, remove the button
						if (currentPage >= maxPage) $button.remove();
					} else {
						// if no data, remove the button as well
						$button.remove();
					}
				},
				error() {
					// Restore initial button text
					$button.text(buttonText);
				}
			});
		});
};

export default initShowMorePosts;
